// App.js
import "./common.css";
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router } from "react-router-dom";
import Approutes from "./routes/routes";
import { ToastContainer } from "react-toastify";
import AuthWatcher from "./redux/authWatcher";
import ResizableLayout from "./components/ResizableLayout";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useDispatch, useSelector } from "react-redux";
import { fetchWalletBalance, updateWalletBalance } from "./redux/slices/walletSlice";
import { useEffect } from "react";
import { LoadScript } from "@react-google-maps/api";  

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY || '');
const libraries = ["drawing", "geometry", "places"]; 

function App() {
  const dispatch = useDispatch();
  const { loaded } = useSelector((state) => state.wallet);
  const { user } = useSelector((state) => state?.auth);

  useEffect(() => {
    if (user && !loaded) {
      dispatch(fetchWalletBalance());
    }
  }, [user, loaded, dispatch]);

  useEffect(() => {
    if (!user) return;

    const ws = new WebSocket(`${process.env.REACT_APP_WEBSOCKET_URL}/wallet/${user.id}/`);

    ws.onopen = () => console.log("✅ WebSocket connected");
    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.balance !== undefined) {
          dispatch(updateWalletBalance(data.balance));
        }
      } catch (err) {
        console.error("WebSocket parse error:", err);
      }
    };
    ws.onclose = () => console.log("❌ WebSocket disconnected");
    ws.onerror = (err) => console.error("WebSocket error:", err);

    return () => ws.close();
  }, [user, dispatch]);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const iframe = document.querySelector(".googlelogin iframe");
      if (iframe) iframe.remove();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    <Elements stripe={stripePromise}>
      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_MAP_API_KEY || ""}
        libraries={libraries}
        version="3.64"
      >
        <Router>
          <AuthWatcher />
          <ResizableLayout />
          <Approutes />
          <ToastContainer />
        </Router>
      </LoadScript>
    </Elements>
  );
}

export default App;
